import "@fontsource/space-grotesk/latin-ext-400.css";
import "@fontsource/space-grotesk/latin-ext-600.css";
import "@fontsource/space-grotesk/latin-ext-700.css";
import "@fontsource/space-mono/latin-ext-400.css";
import "@fontsource/space-mono/latin-ext-700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "./app.css";
import { AuthProvider } from "./auth/AuthProvider";
import { initializeFirebaseAppCheck } from "./firebase/firebaseClient";

async function startApplication() {
  try {
    await initializeFirebaseAppCheck();
  } catch (error) {
    console.error("Firebase App Check initialization failed.", error);
  }

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </React.StrictMode>,
  );
}

void startApplication();
